import React from 'react'
import { Autocomplete } from '@react-google-maps/api'

interface AutoCompleteProps {
  theMap: google.maps.Map;
  onPlaceSelect?: (place: google.maps.places.PlaceResult) => void;
}

const AutoComplete: React.FC<AutoCompleteProps> = ({ theMap, onPlaceSelect }) => {
  const onLoad = (autocomplete: google.maps.places.Autocomplete) => {
    autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
  }

  const onPlaceChanged = () => {
    const autocomplete = document.getElementById('autocomplete') as HTMLInputElement;
    const service = new google.maps.places.PlacesService(theMap);
    const request = {
      placeId: autocomplete.getAttribute('data-place-id') || '',
      fields: ['address_components', 'geometry', 'icon', 'name']
    };

    service.getDetails(request, (place, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK && place && onPlaceSelect) {
        onPlaceSelect(place);
      }
    });
  }

  return (
    <Autocomplete
      onLoad={onLoad}
      onPlaceChanged={onPlaceChanged}
    >
      <input
        id="autocomplete"
        type="text"
        placeholder="Search for a location"
        style={{
          boxSizing: `border-box`,
          border: `1px solid transparent`,
          width: `240px`,
          height: `32px`,
          padding: `0 12px`,
          borderRadius: `3px`,
          boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
          fontSize: `14px`,
          outline: `none`,
          textOverflow: `ellipses`,
          position: 'absolute',
          top: '10px',
          left: '10px',
          zIndex: 1
        }}
      />
    </Autocomplete>
  )
}

export default AutoComplete
